import React from 'react';
import Select from 'react-select';
import SelectValue from '../../../component/dict/simple/select/SelectValue';

export const ROLES = [
  { value: 'ROLE_ADMIN', label: 'Admin' },
  { value: 'ROLE_OPERATIONS', label: 'Ops' },
  { value: 'ROLE_OPERATIONS_LIMITED', label: 'Ops limited' },
  { value: 'ROLE_OPERATIONS_HEAD', label: 'Head ops' },
  { value: 'ROLE_FINANCE', label: 'Financial' },
  { value: 'ROLE_TRADER', label: 'Trader' },
  { value: 'ROLE_TRADER_HEAD', label: 'Head trader' },
  { value: 'ROLE_DEVELOPER', label: 'Developer' },
  { value: 'ROLE_CHARTERING', label: 'Chartering' },
  { value: 'ROLE_MANAGEMENT', label: 'Management' },
  { value: 'ROLE_GUEST', label: 'Guest' },
  { value: 'ROLE_EMAIL_ADMIN', label: 'Email admin' },
  { value: 'ROLE_HEAD_CHARTERING', label: 'Head chartering' },
];

export class RoleElement extends React.Component {
  constructor(props) {
    super(props);
    this.options = ROLES;
  }

  render() {
    return (
      <Select
        valueComponent={SelectValue}
        options={this.options}
        value={this.props.roles}
        onChange={(this.props.handleRolesChange ? this.props.handleRolesChange : () => ({}))}
        multi={this.props.multi}
        disabled={this.props.disabled}
      />);
  }
}

RoleElement.propTypes = {
  roles: React.PropTypes.array.isRequired,
  handleRolesChange: React.PropTypes.func,
  multi: React.PropTypes.bool,
  disabled: React.PropTypes.bool,
};
